<template lang="html">
  <div class="col-12" v-if="survey">
      <b-row v-if="!completed && !personalStep && !exist">
        <nps
          v-if="currentStep.type === 'NPS'"
          :question="currentStep"
          class="align-middle"
          v-on:change-step="getNextStep"
        ></nps>
        <simple-text
          v-if="currentStep.type === 'TEXT'"
          :question="currentStep"
          v-on:change-step="getNextStep"
        ></simple-text>
        <smiley
          v-if="currentStep.type === 'SMILEY'"
          :question="currentStep"
          :order="client.order_smiley"
          v-on:change-step="getNextStep"
        ></smiley>
        <list
          v-if="currentStep.type === 'LIST'"
          :question="currentStep"
          v-on:change-step="getNextStep"
        ></list>
        <check
          v-if="currentStep.type === 'CHECK'"
          :question="currentStep"
          v-on:change-step="getNextStep"
        ></check>
        <radio
          v-if="currentStep.type === 'RADIO'"
          :question="currentStep"
          v-on:change-step="getNextStep"
        ></radio>
        <numeral
          v-if="currentStep.type === 'NUMERAL'"
          :question="currentStep"
          v-on:change-step="getNextStep"
        ></numeral>
      </b-row>
      <b-row v-if="!completed && personalStep">
          <personal v-for="(question, index) in survey.personal_info" :key="question.id" :question="question"> </personal>
      </b-row> 

      <b-row v-if="!completed && !exist">
        <b-col class="center-buttom-footer" align-self="start">
        </b-col>
        
        <b-col class="center-buttom-footer" align-self="end">
          <v-btn outline @click="sendData()" :disabled="validateNextStep" :style="{ color:client.color }" class="btn-sgt">
            <i class="material-icons">
              arrow_forward
            </i>
          </v-btn>
        </b-col>
        
      </b-row>
      <b-row v-if="exist">
        <b-col align-self="center">
          <h2>La encuesta se puede contestar 1 vez por día como máximo, visitanos mañana y podrás contestar nuevamente</h2> 
          <h3>¡Muchas gracias por su tiempo!</h3>
        </b-col>
      
      </b-row>
  </div>
</template>

<script>

import Vue from 'vue';
import axios from 'axios';

import Nps from '../v2/components/Nps.vue';
import SimpleText from '../v2/components/SimpleText.vue';
import Radio from '../v2/components/Radio.vue';
import Check from '../v2/components/Check.vue';
import Smiley from '../v2/components/Smiley.vue';
import List from '../v2/components/List.vue';
import Numeral from '../v2/components/Numeral.vue';
import Personal from '../v2/components/Personal.vue';

export default {
  components: {
    Nps,
    SimpleText,
    Radio,
    Check,
    Numeral,
    Smiley,
    List,
    Personal
  },
  props: {
    survey: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    device: {
      type: Object,
      required: true
    },
    tokenResponse: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      exist: false,
      activeStep: 0,
      completed: false,
      nextQuestionId: null,
      previusQuestionIdAux: null,
      personalStep: false
    };
  }, 
  computed: {
    currentStep: function () {
      return this.survey ? this.survey.steps[this.activeStep] : false;  
    },
    validateNextStep: function () {
      if (this.currentStep) {
    
        if (this.currentStep.type === 'NPS' && this.currentStep.value === null) {
          return true;
        }

        if (this.currentStep.type === 'CHECK' && this.currentStep.options_values.length === 0) {
          return true;
        }

        if (this.currentStep.type === 'LIST' && this.currentStep.value === null) {
          return true;
        }

        if (this.currentStep.type === 'NUMERAL' && this.currentStep.value === null) {
          return true;
        }
        
        if (this.currentStep.type === 'SMILEY' && this.currentStep.value === null) {
          return true;
        }
        
        if (this.personalStep) {
          for (let index = 0; index < this.survey.personal_info.length; index++) {
            if (this.survey.personal_info[index].required && !this.survey.personal_info[index].value) {
              return true;
            }
          }
        }

      }

      return false;
    }
  },
  mounted () {
    this.validateIfExistResponse();
  },
  methods: {
    getNextStep (values) {
      this.nextQuestionId = values.nextQuestionId;
      this.previusQuestionIdAux = values.previusQuestionId; 
    },
    validateIfExistResponse () {
      let code = this.$route.query.code ? this.$route.query.code : null;
      let date = this.$route.query.date ? this.$route.query.date : null;
      let url = `public/rounds/${this.survey.id}/responses?code=${code}`;

      axios.get(url).then((response) => {
        this.exist = response.data.exist;
      });
    },
    changeStep () {
      this.previustQuestionId = this.previusQuestionIdAux;

      if (this.nextQuestionId == null && this.survey.personal_info.length === 0) {
        /* Case of not have personal info questions */
        this.resetSurvey();
      } else if (this.nextQuestionId == null && this.personalStep) {
        /* Case of end survey next aflter Personal step */
        this.resetSurvey();
      } else if (this.nextQuestionId) {
        /* Case of have next_question_id survey next */
        this.survey.steps.forEach((step, index) => {
          if (step.id === this.nextQuestionId) {
            this.activeStep = index;
          }
        });
      } else {
        this.personalStep = true;
      }
    },
    sendData () {
      let code = this.$route.query.code ? this.$route.query.code : null;
      let date = this.$route.query.date ? this.$route.query.date : null;

      let url = 'public/v2/survey/device/store';

      if (this.personalStep) {
        url = 'public/v2/survey/device/store-personal';
      }
      
      let coords = JSON.parse(localStorage.getItem('coords'));
      let latitude = coords.latitude;
      let longitude = coords.longitude;

      let self = this;
      const payload = {
        code: code,
        date: date,
        round_id: self.survey.id,
        device_id: self.device.id,
        token: self.tokenResponse,
        latitude: latitude,
        longitude: longitude,
        question: {
          id: self.currentStep.id,
          value: self.currentStep.value,
          options_values: self.currentStep.options_values,
          type: self.currentStep.type,
          option_id: self.currentStep.option_id,
        },
        /* Personal */
        questions: self.survey.personal_info
      };
      
      axios.post(url, payload).then(response => {     
      }).catch(error => {
        console.log(error);
      });  
      
      self.changeStep();

    },
    resetSurvey () {
      
      this.$emit('reset-survey', {
        'message_answered': this.survey.message_answered,
        'message_expired': this.survey.message_expired,
        'message_sub': this.survey.message_sub,
        'message_success': this.survey.message_success,
        'auto_refresh': this.survey.auto_refresh
      });
      /* Add delay because, clear values before saving */
      setTimeout(function () {
        this.survey.steps.forEach((step, index) => {
          step.value = null;
          step.option_id = null;
          step.options_values = [];
        });
        this.survey.personal_info.forEach((personal, index) => {
          personal.value = null;
          personal.option_id = null;
          personal.options_values = [];
        });
      }.bind(this), 2000);

      this.completed = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/surveys/componentSurveyDevices/SurveyAdvanced.vue